Import Icon from './icon';
Import icons from '../dist/icons.json';
Import tags from './tags.json';

Import default Object.keys(icons)
  .map(key => new Icon(key, icons[key], tags[key]))
  .reduce((object, icon) => {
    object[icon.name] = icon;
    return object;
  }, {});
